import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import {
  IconClockRecord,
  IconFile,
  IconFileCheck,
  IconFileUnknown,
  IconBell,
  IconTrendingUp,
  IconExclamationCircle,
} from "@tabler/icons-react";

import i18n from "multitenancy/i18n";

const t = (key: string) => i18n.t(key);

export interface IScheduleMenuList {
  id: number;
  title: string;
}

export const getScheduleMenuList = (): IScheduleMenuList[] => [
  { id: 1, title: t("dashboard.week") },
  { id: 2, title: t("dashboard.month") },
  { id: 3, title: t("dashboard.year") },
];

export function capitalizeFirstLetter(text: string): string {
  if (text.length === 0) {
    return text;
  }
  return text.charAt(0).toUpperCase() + text.slice(1).toLocaleLowerCase();
}

export type IIcon =
  | "Ativas"
  | "Duração média"
  | "Inativas"
  | "Notificadas"
  | "Gravadas"
  | "Registradas"
  | "Em andamento"
  | "Com erro";

const iconDescriptionMap: Record<string, string> = {
  "Registradas": "registered",
  "Ativas": "active",
  "Inativas": "inactive",
  "Notificadas": "notified",
  "Gravadas": "recorded",
  "Em andamento": "inProgress",
  "Com erro": "withError",
  "Duração média": "averageDuration",
};

export const getTranslatedDescription = (description: string): string => {
  const key = iconDescriptionMap[description];
  return key ? t(`dashboard.${key}`) : description;
};

export const ShowIcon = ({ description }: { description: IIcon }) => {
  switch (description) {
    case "Registradas":
      return <IconFile stroke={2} />;
    case "Ativas":
      return <IconFileCheck stroke={2} />;
    case "Inativas":
      return <IconFileUnknown stroke={2} />;
    case "Notificadas":
      return <IconBell stroke={2} />;
    case "Gravadas":
      return <VideocamOutlinedIcon />;
    case "Em andamento":
      return <IconTrendingUp stroke={2} />;
    case "Com erro":
      return <IconExclamationCircle stroke={2} />;
    case "Duração média":
      return <IconClockRecord stroke={2} />;
    default:
      return <IconClockRecord stroke={2} />;
  }
};
